import { IdentityDto } from './../shared/identity.dto';
import { EntityDto } from './../entity/entity.dto';

import { SpecDto } from './spec.dto';
import { PlanogramDetailsDto } from './planogram-details.dto';

export class ProductGroupDto {
  identity: IdentityDto;
  entity: EntityDto;
  clientId: string;
  specs: SpecDto[];
  account: string;
  planogramDetails: PlanogramDetailsDto;
  shipperUPC: boolean;
  productGroupIdentifier: number;

  constructor(d?: ProductGroupDto) {
    if (!d) {
      return;
    }

    Object.assign(this, d);
  }
}
